const map = {
	"./b-cookies-popup": 21893,
	"./b-cookies-popup.js": 21893,
	"./b-faq": 29161,
	"./b-faq.js": 29161,
	"./b-footer.v4": 97452,
	"./b-footer.v4.js": 97452,
	"./b-gallery": 58647,
	"./b-gallery.js": 58647,
	"./b-modal-alert": 99587,
	"./b-modal-alert.js": 99587,
	"./b-modal-tariff-selection": 14560,
	"./b-modal-tariff-selection.js": 14560,
	"./b-sticky-area": 40802,
	"./b-sticky-area.js": 40802,
	"./b-top_menu.v4": 63328,
	"./b-top_menu.v4.js": 63328,
	"./custom_content": 91081,
	"./custom_content.js": 91081,
	"./landing_lead_form": 2695,
	"./landing_lead_form.js": 2695,
	"./red_headline": 33304,
	"./red_headline.js": 33304
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47896;